module.exports = __webpack_public_path__ + "img/gwt-icon.4a2528b4.svg";